/**
 * @desc 获取最新一条已完成的msku交易价格
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.omsFlow.SkuPriceRequestDto>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/oms/orderStatistics/getLastMskuPrice`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
